'use strict'

resizeFlg = {}
resizeFlg.pc = true
resizeFlg.sp = true
firstView = ''

url = do ->
  href = location.href.split('/')

  localRegex = /^\d+\.\d+\.\d+\.\d+/
  workRegex = /^.*\/pc\/[^\/]+\/.*$/

  for val , i in href
    if val is '' or i is href.length - 1 and val.indexOf('.')
      href.splice(i,1)

  if localRegex.test(location.hostname) is true or location.hostname.indexOf('localhost') isnt -1
    length = 2

  else if workRegex.test(location.href) is true
    length = 3

    for val , i in href
      if val is 'pc' and href[i-1] is 'work'
        length = 4

  else
    length = 1

  path = ''

  for j in [0..(length)]
    path += href[j]

    if j is 0
      path += '//'

    else
      path += '/'

  return path

pc = ()->
  $.ajax({
    url: '../util/getInstagram/',
    dataType: 'json'
    success: (data)->
      insert = '<ul class="p-instagram__list c-instagram__list js-instagram-list js-slide-list pc">'
      i = 0
      for i in [0..3]
        insert += '<li class="p-instagram__item c-instagram__item">'
        insert += '<a href="' + data[i]['permalink'] + '" target="_blank" rel="nofollow noopener noreferrer">'
        if data[i]['thumbnail_url']
          insert += '<img src="' + data[i]['thumbnail_url'] + '" class="instagram-image" />'
        else
          insert += '<img src="' + data[i]['media_url'] + '" class="instagram-image" />'
        insert += '</a>'
        insert += '</li>'
        i++
      insert += '</ul>'
      $('#instagram-gallery').append(insert)
      return
  })

sp = ()->
  $.ajax({
    url: '../util/getInstagram/',
    dataType: 'json'
    success: (data)->
      insert = '<ul class="p-instagram__list c-instagram__list js-instagram-list js-slide-list sp">'
      i = 0
      for i in [0..8]
        insert += '<li class="p-instagram__item c-instagram__item">'
        insert += '<a href="' + data[i]['permalink'] + '" target="_blank" rel="nofollow noopener noreferrer">'
        if data[i]['thumbnail_url']
          insert += '<img src="' + data[i]['thumbnail_url'] + '" class="instagram-image" />'
        else
          insert += '<img src="' + data[i]['media_url'] + '" class="instagram-image" />'
        insert += '</a>'
        insert += '</li>'
        i++
      insert += '</ul>'
      $('#instagram-gallery').append(insert)
      return
  })

  $(document).ajaxComplete( ->
    $('.js-slide-list.sp').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 900,
      initialSlide: 0,
      swipeToSlide: true,
      centerMode: true,
      variableWidth: true,
      dots: true,
      customPaging: (slick, index)->
        targetImage = '../img/sp/index_sns_instagram_thumb_dot.png'
        return '<img src=" ' + targetImage + ' "/>'
    })
  )

if window.matchMedia('(max-width:750px)').matches
  # SP
  firstView = 'SP'

  sp()
else
  # PC
  firstView = 'PC'

  pc()

$(window).on('resize',
  ()->
    if window.matchMedia('(max-width:750px)').matches
      if firstView is 'PC' and resizeFlg.sp is true or
      firstView is false and resizeFlg.sp is true
      # PC から SP へ

        # $('.js-instagram-list').empty()

        sp()

        resizeFlg.pc = true
        resizeFlg.sp = false
        firstView = false
    else
      if firstView is 'SP' and resizeFlg.pc is true or
      firstView is false and resizeFlg.pc is true
      # SP から PC へ

        $('.js-slide-list.sp').slick('destroy')

        # $('.js-instagram-list').empty()

        pc()

        resizeFlg.pc = false
        resizeFlg.sp = true
        firstView = false
)